// eslint-disable-next-line import/prefer-default-export
export const customBreakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1440,
    lg: 1900,
    xl: 3840,
  },
};
